/**
 * Event dispatched when an unauthorized response (401/403) is received
 * Listen for this event to trigger navigation to the unauthorized page
 */
export const UNAUTHORIZED_EVENT = "api:unauthorized";
